<app-website-header></app-website-header>


<!-- Page Header Section -->
<section class="page-header-section text-center ">

    <div  class="carousel slide">
        <div class="carousel-inner">
            <div class="carousel-item active">
                    <div class="overlay imgOverlay"></div>
                <img src="\assets\images\careers-page-header (1).png" class="d-block w-100 imgOverlay" alt="..." style="height: 400px;width: auto;">
                <div class="carousel-caption d-block d-md-block">
                    <h1 style="font-family: 'Libre Baskerville' !important;width: 100%;">Discover Exciting &nbsp;Job Opportunities</h1>
                    <p style="text-align: justify;">Welcome to the Job Search page, your gateway to exploring a wide range of career 
                        opportunities within the healthcare industry. Whether you're seeking roles at OEMs, Distributors, 
                        or renowned healthcare organizations such as hospitals, clinics, and labs, we’ve got you covered. 

Use our intuitive search tools to filter and discover positions that match your skills and aspirations. </p>

                    <div class="search-bar justify-content-center my-4">
                        <form [formGroup]="searchJobForm" class="row" (ngSubmit)='onSubmit()'>
                            <div class="col-5">
                                <mat-form-field appearance="outline" class="input-font w-100">
                                    <input 
                                      matInput 
                                      type="text" 
                                      class="jobTitle" 
                                      formControlName="speciality" 
                                      placeholder="Enter Speciality"
                                      (input)="onSpecialityFilter($event)"
                                      (focus)="onFocusSpeciality()"
                                      [matAutocomplete]="auto">
                                    
                                    <mat-autocomplete #auto="matAutocomplete">
                                      <mat-option *ngFor="let speciality of filteredSpecialities" [value]="speciality.specialty">
                                        {{ speciality?.specialty }}
                                      </mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                  
                                  
                            </div>
                            <div class="col-5">
                                <mat-form-field appearance="outline" class="input-font w-100">
                                    <input 
                                        matInput 
                                        type="text" 
                                        class="keyWords"
                                        formControlName="keywords"
                                        placeholder="Enter Keywords"
                                        (input)="onKeywordsFilter($event)"
                                        (focus)="onFocusKeywords()"
                                        [matAutocomplete]="keywordAuto">
                                                                            
                                        <mat-autocomplete #keywordAuto="matAutocomplete">
                                            <mat-option *ngFor="let keyword of filteredKeywords" [value]="keyword.name">
                                            {{ keyword?.name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                  </mat-form-field>
                            </div>
                            <div class="col-2 d-none d-md-block">
                                <button type="submit" class="button button-primary success searchSucess">
                                    <img src="/assets/images/search-white.svg" alt="angle-arrow-small-right">
                                    Search</button>
                            </div>
                        </form>
                        <div class="mobileSearch d-md-none" (click)="mobileSearchSubmit()">
                            <button type="submit" class="button button-primary success">
                                <img src="/assets/images/search-white.svg" alt="angle-arrow-small-right">
                                Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Page Header Section -->
<section class="welcome-section">
    <h2 style="font-family: 'Libre Baskerville' !important;" >Welcome to Medworld Expo<br><span style="line-height: 1.5; font-family: 'Libre Baskerville' !important;"> The Premier Platform for Medical Job Careers!</span></h2>
    <div class="row overallWelcomeSection">
        <div class="col-7 welcomeImageSection">
            <img src="/assets/images/careers-welcome-container-image.svg" />
        </div>
        <div class="col-5 welcomeDescriptionSection">
            <div class="welcome-info-container">
                <p style="text-align: justify; font-weight:500; " class="fonts">Discover unparalleled career opportunities in the healthcare industry with Medworld Expo. 
                    Our platform connects job seekers with leading OEMs, Distributors, and Healthcare Organizations across the globe.<br><br>
                     Whether you’re a seasoned professional or just starting your career, 
                     Medworld Expo is your go-to destination for exploring rewarding roles in the medical field. 
                    Join thousands of professionals advancing their careers and making an impact in healthcare. Start your journey with us today! 
                </p>
                <button type="button" class="button button-primary w-auto" (click)="onViewAllJobs()">
                    <img src="/assets/images/angle-arrow-small-right.svg" alt="angle-arrow-small-right">
                    View All Jobs</button>
            </div>
        </div>
    </div>
</section>

<!-- Why Choose Section -->
<section class="why-choose-section">
    <div class="container">
        <h2 style="font-family: 'Libre Baskerville' !important;">Why Choose Medworld Expo</h2>
        <div class="row row-cols-2 row-md whyChooseDiv">
            <div class="col-md-3">
                <img src="../../assets/images/icons/jobs-come-to-you.svg" alt="careers-jobs">
                <p>Jobs Come to You</p>
            </div>
            <div class="col-md-3">
                <img src="/assets/images/icons/jobs-worldwide-jobs.svg" alt="careers-access">
                <p>Access to Worldwide Jobs</p>
            </div>
            <div class="col-md-3">
                <img src="/assets/images/icons/jobs-hospital.svg" alt="careers-hospitals">
                <p>From Top Hospitals & Organizations</p>
            </div>
            <div class="col-md-3">
                <img src="/assets/images/careers-quickly-paid.svg" alt="careers-quickly-paid">
                <p>Apply & Get Paid Quickly</p>
            </div>
        </div>
    </div>
</section>

<!-- How It Works Section -->
<section class="how-it-works-section">
    <div class="container">
        <h2 style="font-family: 'Libre Baskerville' !important; ">How It Works?</h2>
        <div class="header-container">
            <div style="cursor: pointer;">
                <h3 [ngClass]=" selectTab === 0? 'active': ''" (click)="activeTab(0)"><span class="numberCircle"><span>1</span></span> Create Your Profile</h3>
            </div>
            <div style="cursor: pointer;">
                <h3 [ngClass]=" selectTab === 1? 'active': ''" (click)="activeTab(1)"><span class="numberCircle"><span>2</span></span> Explore Jobs</h3>
            </div>
            <div style="cursor: pointer;">
                <h3 [ngClass]=" selectTab === 2? 'active': ''" (click)="activeTab(2)"><span class="numberCircle"><span>3</span></span> Get A Chance to Work</h3>
            </div>
        </div>


        <div class="row info-conatiner">
            <div class="col-md-8">
                <p *ngIf="selectTab === 0" style="text-align: justify;">Take the first step towards your dream job by creating a profile on Medworld Expo.
                     Showcase your skills, qualifications, and experience to make yourself visible to top healthcare organizations.
                      A complete profile ensures you get matched with the most relevant job opportunities. 

                </p>
                <p *ngIf="selectTab === 1" style="text-align: justify;">Browse through a wide range of job listings from leading OEMs, Distributors, 
                    and Healthcare Organizations. Use advanced filters to find the perfect fit for your expertise, 
                    whether you're looking for clinical, technical, or administrative roles.
                     Explore the opportunities waiting for you. </p>
                <p *ngIf="selectTab === 2" style="text-align: justify;">Unlock exciting career possibilities by connecting with global healthcare leaders.
                     Apply to positions directly through Medworld Expo and get a chance to work with
                    renowned organizations that are shaping the future of medical technology and patient care. </p>

                    <a *ngIf="isNew" [routerLink]="['/user/signup']">
                <button type="button" class="button button-primary w-auto newSignUpButton">
                    <img src="/assets/images/angle-arrow-small-right.svg" alt="angle-arrow-small-right">
                    Sign up</button></a>
            </div>
            <div class="col-md-4">
                <img src="/assets/images/careers-works-doctor.jpg" width="203px" height="227px" class="careers-works-doctor" alt="careers-hospitals">
            </div>
        </div>

    </div>
</section>

<app-website-footer></app-website-footer>
